import FormWeightInput from './FormWeightInput';

export type { FormWeightInputProps } from './FormWeightInput';

export default FormWeightInput;
